import styled from 'styled-components';

export const Container = styled.div`
  label,
  legend {
    font-size: 15px;
  }

  .card-text {
    font-size: 17px;
  }

  .btn-link {
    color: #28c893;
  }

  .btn-submit {
    background-color: #28c893;
    color: #fff;
    border: 1px solid #28c893;
  }

  .form-check-input {
    accent-color: #28c893;
  }

  .pre-line {
    white-space: pre-line;
  }

  .status-screen-check {
    font-size: 48px;
    color: #28c893;
  }

  .status-timeline {
    list-style: none;
    margin: 0;
    padding: 0;
  }

  .status-item {
    position: relative;
    display: flex;
    gap: 12px;
    padding-bottom: 22px;
  }

  .status-item:last-child {
    padding-bottom: 0;
  }

  .status-item::before {
    content: '';
    position: absolute;
    left: 15px;
    top: 32px;
    bottom: 0;
    width: 2px;
    background: #e9ecef;
  }

  .status-item:last-child::before {
    display: none;
  }

  .status-item-marker {
    flex: 0 0 auto;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #e9ecef;
    color: #adb5bd;
    z-index: 1;
  }

  .status-item-marker .material-icons {
    font-size: 20px;
  }

  .status-item.done .status-item-marker,
  .status-item.current .status-item-marker {
    background: #28c893;
    color: #fff;
  }

  .status-item.done::before {
    background: #28c893;
  }

  .status-item.current .status-item-marker {
    box-shadow: 0 0 0 4px rgba(40, 200, 147, 0.2);
  }

  .status-item-label {
    font-size: 16px;
  }

  .status-item.current .status-item-label {
    font-weight: 700;
  }

  .status-item.upcoming .status-item-label {
    color: #6c757d;
  }

  .status-item-desc {
    color: #6c757d;
    font-size: 14px;
  }

  .status-item.current.tone-warning .status-item-marker {
    background: #f0ad4e;
    box-shadow: 0 0 0 4px rgba(240, 173, 78, 0.2);
  }

  .status-item.current.tone-negative .status-item-marker {
    background: #dc3545;
    box-shadow: 0 0 0 4px rgba(220, 53, 69, 0.2);
  }

  .status-item.current.tone-warning .status-item-label {
    color: #b9770e;
  }

  .status-item.current.tone-negative .status-item-label {
    color: #dc3545;
  }
`;
